import { calcSpecificDiscount } from "./discount";
import { roundThis } from "../utilities/utils";

function calcDiscount(discountInfo, station, timeslot, quantity) {
  let toReturn = {
    quantity: 0,
    price: 0,
    name: '',
    isDiscount: false,
    appliedToCart: false
  };
  if (discountInfo.timeslots.hasOwnProperty(timeslot.timeslotId)) {
    const discount = discountInfo.timeslots[timeslot.timeslotId];
    if (discount.hasOwnProperty(station.itemId)) {
      const itemDiscount = discount[station.itemId];
      const req = itemDiscount.requirements;
      let body = {
        req,
        appliedToCart: false,
        evaluateCart: discountInfo.evaluateCart,
        selectedQuantity: quantity,
        discountQuantity: req.item_quantity,
        itemPrice: station.price,
        cartPrice: 0, // doesn't matter
        discountPrice: req.discount_amount,
        curAmtSaved: 0 // doesn't matter
      };
      body = calcSpecificDiscount(body);

      toReturn = {
        ...toReturn,
        quantity: body.discountQuantity,
        price: body.discountPrice,
        name: itemDiscount.name,
        isDiscount: true,
        appliedToCart: body.appliedToCart
      };
    }
  }
  return toReturn;
}

// The current implementation only considers timeslots from stations when considering selected items
// which is fine for now because items can only be purchased at timeslots that have stations
// If performance becomes an issue then each sub category should be broken out into its own memoized selector (Reselect library)
export function getLineItems(state, discountInfo) {
  let lineItems = [];
  let cartDiscount = 0;

  const stationsData = state.station.stationsData;
  if (stationsData) {
    stationsData.timeslots.forEach((timeslot) => {
      let lines = [];
      // Get station line items
      const stationMap = state.station.selectedStations[timeslot.timeslotId];
      const extraData = state.station.selectedExtra[timeslot.timeslotId];
      if (stationMap) {
        Object.keys(stationMap).forEach((stationId) => {
          const quantity = stationMap[stationId];
          if (quantity !== undefined && quantity > 0) {
            const station = stationsData.stations[stationId];
            if (station) {
              lines.push({
                quantity: quantity,
                price: station.price,
                name: station.title,
                isDiscount: false
              });

              if (extraData) {
                const extraQuantity = extraData[stationId];
                if (extraQuantity !== undefined && extraQuantity - quantity > 0) {
                  lines.push({
                    quantity: extraQuantity - quantity,
                    price: station.participantExtra[0].amount,
                    name: 'Additional Person Fee',
                    isDiscount: false
                  });
                }
              }

              // discounts
              const discount = calcDiscount(discountInfo, station, timeslot, quantity);
              if (discount.isDiscount && !discount.appliedToCart) {
                lines.push({
                  quantity: discount.quantity,
                  price: discount.price,
                  name: discount.name,
                  isDiscount: discount.isDiscount
                });
              } else if (discount.appliedToCart) cartDiscount += discount.price;
            }
          }
        });
      }
      if (lines.length > 0) {
        lineItems.push({
          timeslotId: timeslot.timeslotId,
          time: timeslot.moment.format('h:mm a').toLocaleUpperCase(),
          lines: lines
        });
      }
    });
  }

  const partyRoomsData = state.partyRoom.partyRoomsData;
  if (partyRoomsData) {
    partyRoomsData.timeslots.forEach((timeslot) => {
      let lines = [];
      // Get Partyroom line items
      const partyRoomMap = state.partyRoom.selectedPartyRooms[timeslot.timeslotId];
      if (partyRoomMap) {
        Object.keys(partyRoomMap).forEach((partyRoomId) => {
          const quantity = partyRoomMap[partyRoomId];
          if (quantity !== undefined && quantity > 0) {
            const partyRoom = partyRoomsData.partyRooms[partyRoomId];
            if (partyRoom) {
              lines.push({
                quantity: quantity,
                price: partyRoom.price,
                name: partyRoom.title,
                isDiscount: false
              });

              // discounts
              const discount = calcDiscount(discountInfo, partyRoom, timeslot, quantity);
              if (discount.isDiscount && !discount.appliedToCart) {
                lines.push({
                  quantity: discount.quantity,
                  price: discount.price,
                  name: discount.name,
                  isDiscount: discount.isDiscount
                });
              }
              else if (discount.appliedToCart) {
                cartDiscount += discount.price;
              }
            }
          }
        });
      }
      if (lines.length > 0) {
        lineItems.push({
          timeslotId: timeslot.timeslotId,
          time: timeslot.moment.format('h:mm a').toLocaleUpperCase(),
          lines
        });
      }
    });
  }

  if (cartDiscount > 0 || (discountInfo && discountInfo.evaluateCart)) {
    lineItems.push({
      timeslotId: 0,
      time: '',
      lines: [
        {
          quantity: 1,
          price: (discountInfo && discountInfo.evaluateCart) ? discountInfo.evaluateCartDiscount.total : cartDiscount,
          name: discountInfo.title,
          isDiscount: true,
          appliedToCart: true
        }
      ]
    });
  }

  return lineItems;
}

// If performance becomes an issue then each sub category should be broken out into its own memoized selector (Reselect library)
// Returns the total price of all selected line items
export function getPrice(state, discountInfo) {
  let totalBasePrice = 0;
  let totalDiscount = 0;
  let totalTax = 0;

  // Get price of stations
  const stationState = state.station;
  const stationsData = stationState.stationsData;
  if (stationsData) {
    stationsData.timeslots.forEach((timeslot) => {
      let timeslotBasePrice = 0;
      let timeslotDiscount = 0;
      const selectedStations = stationState.selectedStations[timeslot.timeslotId];
      if (selectedStations !== undefined) {
        Object.keys(selectedStations).forEach((stationId) => {
          const station = stationsData.stations[stationId];
          const quantity = selectedStations[stationId];
          if (station !== undefined && quantity !== undefined) {

            // get dem extras and add ons
            const extra = stationState.selectedExtra[timeslot.timeslotId];
            if (extra) {
              const extraQuantity = extra[stationId];
              if (extraQuantity !== undefined && extraQuantity > 0) {
                station.participantExtra.map((extraData) => {
                  totalBasePrice += extraData.amount * (extraQuantity - quantity);
                  return null;
                });
              }
            }
            timeslotBasePrice += roundThis(quantity * station.price);

            const gotDiscount = calcDiscount(discountInfo, station, timeslot, quantity);
            timeslotDiscount = roundThis(timeslotDiscount + (gotDiscount.price * gotDiscount.quantity));
          }
        });
        totalBasePrice = roundThis(totalBasePrice + timeslotBasePrice);
        totalDiscount = roundThis(totalDiscount + timeslotDiscount);
      }
    });
  }

  // Get price of party rooms
  const partyRoomState = state.partyRoom;
  const partyRoomsData = partyRoomState.partyRoomsData;
  if (partyRoomsData) {
    partyRoomsData.timeslots.forEach((timeslot) => {
      let timeslotBasePrice = 0;
      let timeslotDiscount = 0;
      const selectedPartyRooms = partyRoomState.selectedPartyRooms[timeslot.timeslotId];
      if (selectedPartyRooms !== undefined) {
        Object.keys(selectedPartyRooms).forEach((partyRoomId) => {
          const partyRoom = partyRoomsData.partyRooms[partyRoomId];
          const quantity = selectedPartyRooms[partyRoomId];
          if (partyRoom !== undefined && quantity !== undefined) {
            timeslotBasePrice += roundThis(quantity * partyRoom.price);

            const gotDiscount = calcDiscount(discountInfo, partyRoom, timeslot, quantity);
            timeslotDiscount = roundThis(timeslotDiscount + (gotDiscount.price * gotDiscount.quantity));
          }
        });
      }
      totalBasePrice = roundThis(totalBasePrice + timeslotBasePrice);
      totalDiscount = roundThis(totalDiscount + timeslotDiscount);
    });
  }

  if (discountInfo && discountInfo.evaluateCart) {
    totalDiscount = discountInfo.evaluateCartDiscount.total;
  }

  // get tax data from selected location
  let taxes = [];
  const locationState = state.bookingLocation;
  const locationData = locationState.selectedLocation;

  if (locationData && locationData.tax_types) {
    for (let i in locationData.tax_types) {
      const tt = locationData.tax_types[i];
      const subTotal = Math.max(totalBasePrice - totalDiscount, 0);
      const total = roundThis(subTotal * (tt.tax_rate / 100));
      totalTax = roundThis(totalTax + total);
      taxes.push({
        type: tt.tax_type,
        number: tt.tax_number,
        rate: tt.tax_rate,
        total
      });
    }
  }
  return {
    basePrice: totalBasePrice,
    discount: totalDiscount,
    tax: totalTax,
    taxes
  };
}
